import request from "@/utils/request";

/**
 * 获取系统信息
 */
export function apiGetSystem() {
  return request.get("/setting/getSystem");
}

/**
 * 获取公开系统信息
 */
export function apiGetPublicSystem() {
  return request.get("/setting/publicSystem");
}

/**
 * 设置系统信息
 * @param params
 */
export function apiSetSystem(params) {
  return request.post("/setting/setSystem", { ...params });
}

/**
 * 获取邮箱信息
 */
export function apiGetMailer() {
  return request.get("/setting/getMailer");
}

/**
 * 设置邮箱信息
 * @param params
 */
export function apiSetMailer(params) {
  return request.post("/setting/setMailer", { ...params });
}

export function apiTryMailer(params) {
  return request.post("/setting/tryMailer", { ...params });
}

export function apiAdminOperationLogList(params) {
  return request.get("/adminOperationLog/list", params);
}

export function apiAdminOperationLogAdminOptions() {
  return request.get("/adminOperationLog/adminOptions");
}

export function apiWechatSettings() {
  return request.get("/wechat/settings");
}

export function apiWechatSaveSettings(params) {
  return request.post("/wechat/saveSettings", params);
}

export function apiWechatTestAccessToken() {
  return request.post("/wechat/testAccessToken");
}

export function apiWechatTestTemplate(params) {
  return request.post("/wechat/testTemplate", params);
}

export function apiWechatNotifications(params) {
  return request.get("/wechat/notifications", params);
}

export function apiWechatBindings(params) {
  return request.get("/wechat/bindings", params);
}

export function apiWechatSetCustomerNotify(params) {
  return request.post("/wechat/setCustomerNotify", params);
}

export function apiWechatResend(params) {
  return request.post("/wechat/resend", params);
}
